<template>
  <div class="main-resource">

    <main>
      <header>
        <h3>资源管理</h3>
        <!-- <span>/ computer management</span> -->
        <div class="btn-group">
          <a-button v-if="$IA('system:resource:save')" type="primary" icon="plus" @click="handleOpen('添加')">添加</a-button>
        </div>
      </header>
      <!-- 数据表格 -->
      <a-table  :loading="tableLoad" bordered  style="margin-top: 16px" :columns="tableColumns" :data-source="tableData"  @change="handleTableChange"   :scroll="{ y: 670 }"   :pagination="false"  rowKey="id" >
        <span slot="num" slot-scope="text, record, index">
          {{ (Page.current - 1) * Page.pageSize + parseInt(index) + 1 }}
        </span>
        <span slot="customTitle">资源名称</span>
        <template slot="type" slot-scope="text">
          <a-tag
            color="geekblue"
          >
              {{typeList[text]}}
          </a-tag>
        </template> 
        <template slot="isHide" slot-scope="text">
          <span v-if="text === 0"><a-tag color="blue">显示</a-tag></span>
          <span v-else><a-tag color="red">隐藏</a-tag></span>
        </template>
        <span slot="action" slot-scope="text, record" class="table-action-box">
             <a-tooltip  content="" v-if="$IA('system:resource:update')" title="修改" placement="top" effect="light">
              <i class="table-edit"  @click="handleOpen('修改',record)" ></i>
            </a-tooltip>
            <a-tooltip  content="" v-if="$IA('system:resource:delete')" title="删除" placement="top" effect="light">
              <i class="table-delected"  @click="handleOpen('删除',record)" ></i>
            </a-tooltip>
        </span>
      </a-table>
    </main>

    <!-- 添加 -->
    <a-modal
      centered
      :title="modalTitle + '资源'"
      :visible="modalVisible"
      :confirm-loading="btnLoad"
      @ok="handleOk('userForm')"
      :width="modalTitle == '删除' ? '420px' : '580px'"
      :confirmLoading="submitLoad"
      @cancel="resetForm"
      :maskClosable="false"
    >
      <a-form-model v-if="['添加', '修改'].includes(modalTitle)" :model="userForm" ref="userForm"  :rules="addFormRules">
        <a-form-model-item  prop="id" v-show="false">
             <a-input v-model="userForm.id" placeholder="请输入" />
        </a-form-model-item>
        <a-row :gutter="24">
          <a-col :span="12">
            <a-form-model-item label="上级资源" prop="parentId"   
                  >
                  <a-tree-select
                  v-model='userForm.parentId'
                  style="width: 100%"
                  :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                  :tree-data="treeData"
                  placeholder="选择资源"
                  tree-default-expand-all
                  :replaceFields="{ title: 'name', key: 'id',value:'id' }"
                >
                </a-tree-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="资源名称"  prop="name">
              <a-input v-model="userForm.name" placeholder="请输入" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="资源KEY" prop="sourceKey">
              <a-input v-model="userForm.sourceKey" placeholder="请输入" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="资源类型" prop="type">
              <a-select v-model="userForm.type" placeholder="请输入">
                <a-select-option :value="0">目录</a-select-option>
                <a-select-option :value="1">菜单 </a-select-option>
                <a-select-option :value="2">按钮 </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>

          <a-col :span="12">
            <a-form-model-item label="资源URL" prop="sourceUrl">
              <a-input v-model="userForm.sourceUrl" placeholder="请输入" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="层级" prop="resourceLevel">
              <a-input-number :min="0" :max="10" :precision="0" v-model="userForm.resourceLevel" placeholder="请输入" style="width: 100%" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="排序" prop="sort">
              <a-input-number :min="0" :max="9999" :precision="0" v-model="userForm.sort" placeholder="请输入"  style="width: 100%"/>
            </a-form-model-item>
          </a-col>
         
          <a-col :span="12">
            <a-form-model-item label="状态" prop="isHide">
              <a-select v-model="userForm.isHide" placeholder="请输入">
                <a-select-option :value="0">显示</a-select-option>
                <a-select-option :value="1">隐藏 </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>

       
        </a-row>
        <template slot="footer">
          <a-button key="back" @click="modalVisible = false"> 取消 </a-button>
          <a-button key="submit" :loading="loading" type="primary" @click="handleOk">
            提交
          </a-button>
        </template>
      </a-form-model>


      <div class="deleteBox" v-if="modalTitle == '删除'">
        <a-icon type="exclamation-circle" theme="filled" />
        <p>此操作将永久删除该资源,是否继续?</p>
      </div>
    </a-modal>
  </div>
</template>

<script>
import {notification} from "ant-design-vue";

export default {
  data() {
    return {
      btnLoad: false,
      loading:false,
      tableLoad: false,
      submitLoad:false,
      userForm: {
        id:"",
        name: "",
        parentId:undefined,
        sourceKey: "",
        isHide: undefined,
        type: undefined,
        sourceUrl: "",
        resourceLevel: "",
        sort: "",
        icon: "",
        description: "",
      },
      pagination: {
        searchText: "",
        type: undefined,
        pageSize: 10,
        current: 1,
        total: 0,
      },
      typeList:{
        0:"目录",
        1:"菜单",
        2:"按钮"   
      },
      tableColumns: [
        {
          width: '30%',
          dataIndex: "name",
          key: "name",
          slots: { title: "customTitle" },
          scopedSlots: { customRender: "name" },
          ellipsis: true,
        },
        {
          title: "资源KEY",
          dataIndex: "sourceKey",
          key: "sourceKey",
          width: '20%',
          ellipsis: true,
        },
        {
          title: "资源类型",
          dataIndex: "type",
          scopedSlots: { customRender: "type" },
          key: "type",
          align: "center",
          width: 90
        },
        {
          title: "资源URL",
          dataIndex: "sourceUrl",
          key: "sourceUrl",
          width: '20%',
          ellipsis: true,
        },
        {
          title: "层级",
          dataIndex: "resourceLevel",
          key: "resourceLevel",
          width: 70,
          align: 'center'
        },
        {
          title: "排序",
          dataIndex: "sort",
          key: "sort",
          width: 70,
          align: 'center'
        },
        {
          title: "状态",
          dataIndex: "isHide",
          scopedSlots: { customRender: "isHide" },
          key: "isHide",
          width: 70,
          align: 'center'
        },
        {
          title: "创建时间",
          dataIndex: "createTime",
          key: "createTime",
          ellipsis: true,
          width: '15%'
        },
        {
          title: "更新时间",
          dataIndex: "updateTime",
          key: "updateTime",
          ellipsis: true,
          width: '15%'
        },
        {
          title: "操作",
          key: "action",
          align: "center",
          width: 100,
          scopedSlots: { customRender: "action" },
        },
      ],
      // 单行数据
      singleDta: "",
      tableData: [],
      // 模态框显隐
      modalVisible: false,
      // 模态框标题
      modalTitle: "",
      addFormRules: {
        name: [{ required: true, max: 20, message: "资源名称最长不能超过20字符且不可为空" }],
        sourceKey: [{ required: true, max: 100, message: "资源KEY最长不能超过100字符且不可为空" }],
        sourceUrl: [{ required: true, max: 100, message: "资源URL最长不能超过100字符且不可为空" }],
        resourceLevel: [{ required: true, message: "层级不能为空" }],
        sort: [{ required: true, message: "排序不能为空" }],
        description: [{ required: true, max: 250, message: "描述不能为空" }],
        type: [{ required: true, message: "资源类型不能为空" }],
        isHide: [{ required: true, message: "资源状态不能为空" }],
      },
      // 上级资源
      treeData:[],
      // 添加/修改保存API
      saveApi: "",
    };
  },
  methods: {
    // 重置表单通用方法
    resetForm() {
      if ( this.modalTitle =='添加' || this.modalTitle =='修改' ) {
          this.$refs.userForm.resetFields()
      }
      this.modalVisible = false
    },
    // 打开模态框
    handleOpen(title,data) {
      this.modalTitle = title;
      this.resourcesSelect()
      this.modalVisible = true;
      this.$nextTick(()=>{
        this.singleDta = data
        switch (title) {
          case '添加':
            this.saveApi = '/resource/save'
            break;
          case '修改':
            this.saveApi = '/resource/update'
            this.userForm = this.$lodash.pick(
              this.singleDta,
              this.$lodash.keys(this.userForm)
            );
            break;
          case '删除':
            
            break;
        }
      })
    },
    // 确认模态框
    handleOk(formName) {
      if (this.modalTitle == "添加" || this.modalTitle == "修改") {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.submitLoad = true;
            let saveData = "";
            saveData = this.$lodash.cloneDeep(this.userForm);
            this.axios
              .post(this.saveApi, saveData)
              .then((res) => {
                this.submitLoad = false;
                if (res.code === 200) {
                  notification.success({
                    message: res.message,
                    duration: 3,
                    customClass: "batch-import",
                  })
                  this.handleTableChange();
                  this.resetForm()
                }
              })
              .catch((err) => {
                this.submitLoad = false;
                console.log(err);
              });
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      } else {
          this.submitLoad = true;
          this.axios
            .delete("/resource/delete/" + this.singleDta.id)
            .then((res) => {
              this.submitLoad = false;
              if (res.code === 200) {
                notification.success({
                  message: res.message,
                  duration: 3,
                  customClass: "batch-import",
                })
                this.handleTableChange();
                this.modalVisible = false;
              }
            })
            .catch((err) => {
              this.submitLoad = false;
              console.log(err);
            });
      }
    },
    // 流程下拉框
    resourcesSelect() {
      this.axios
        .post("/resource/detailsResource")
        .then((res) => {
          // console.log(res.data);
          if (res.code === 200) {
            this.treeData = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 搜索
    searchChange(v) {
      this.pagination.pageNo = 1;
      if (window.searchTimer) {
        clearTimeout(window.searchTimer);
      }
      window.searchTimer = setTimeout(this.handleTableChange, 1000);
    },
    // 翻页请求
    handleTableChange(pagination, filters, sorter) {
      this.tableLoad = true;
      this.pagination = this.$lodash.merge({}, this.pagination, pagination);
      this.pagination.pageNo = pagination ? pagination.current : 1;
      this.axios
        .post("/resource/findPage", this.$qs.stringify(this.pagination))
        .then((res) => {
          this.tableLoad = false;
          if (res.code === 200) {
            this.tableLoad = false;
            this.tableData = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
          this.tableLoad = false;
        });
    },
  },
  beforeMount() {
    this.handleTableChange();
  },
};
</script>

<style lang="scss" scoped>
.main-resource {

  main {
    margin: 16px;
    background-color: #fff;
    border-radius: 2px;
    header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 16px;
      border-bottom: 1px solid #f0f0f0;

      h3 {
        margin-bottom: 0;
        height: 18px;
        line-height:17px;
        padding-left: 12px;
        border-left: 4px solid #3373F2;
        font-size: 16px;
        font-weight: bold;
        color: #3d4966;
      }

      span {
        line-height: 16px;
        margin-left: 10px;
        color: #808080;
      }
    }
    .toolbar {
      display: flex;
      justify-content: space-between;
      padding: 16px;

      .search-bar {
        flex: 1;
      }
      .ant-form{
        .ant-form-item{
          margin-right: 16px;
        }
        .ant-form-item:last-child{
          .ant-btn{
            width: 74px;
            position: absolute;

          }
        }
      }
    }
    .ant-table-wrapper{
      padding: 0 16px 16px;
    }
  }
}
::v-deep .ant-form-item .ant-form-item-label {
  font-weight: 600;
}

::v-deep .ant-col-12{
    height: 104px;
  }
</style>
